module.exports = __webpack_public_path__ + "img/progress-oman-bar-bg.a6b85343.svg";